import store from '../'

let resource = store.defineResource({
  name: "sessions",
  relations: {
    hasOne: {
      users: {
        localField: "user",
        localKey: "userId"
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/sessions.js